"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIDGET_HIDE_ON_PRINT = exports.SHADOW_CONTAINER = exports.MOBILE = exports.INTERNAL = exports.ALIGNED_RIGHT_CLASS = exports.ALIGNED_LEFT_CLASS = exports.ALIGNED_CENTER_CLASS = exports.ACTIVE = void 0;
const ACTIVE = exports.ACTIVE = 'hs-messages-widget-open';
const MOBILE = exports.MOBILE = 'hs-messages-mobile';
const SHADOW_CONTAINER = exports.SHADOW_CONTAINER = 'hs-shadow-container';
const INTERNAL = exports.INTERNAL = 'internal';
const ALIGNED_LEFT_CLASS = exports.ALIGNED_LEFT_CLASS = 'widget-align-left';
const ALIGNED_RIGHT_CLASS = exports.ALIGNED_RIGHT_CLASS = 'widget-align-right';
const WIDGET_HIDE_ON_PRINT = exports.WIDGET_HIDE_ON_PRINT = 'hs-widget-hide-on-print';
const ALIGNED_CENTER_CLASS = exports.ALIGNED_CENTER_CLASS = 'widget-align-center';